module.exports = __webpack_public_path__ + "assets/img/rakumart-experience-prompt.9bc8f14c.svg";